export default {
  events: {
    OPEN_ENQUIRY: 'Open enquiry form',
    SUBMIT_ENQUIRY: 'Enquiry form submitted',
    CONFIRMED_ENQUIRY: 'Enquiry success',
    ENQUIRY_VALIDATION_ERROR: 'Enquiry form invalid',
  },
  pages: {
    HOME: 'Home page',
    SEARCH: 'Search page',
    HOME_LISTING: 'Home listing',
  }
};




/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/Tracker/Constants.js
 **/